// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-menu {
  position: absolute;
  width: 300px;
  right: -100%;
  top: 65px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 28px 0 rgba(20, 46, 82, 0.2);
  padding: 15px;
  transition: 0.3s;
  z-index: 1;
}
.floating-menu:before {
  content: "";
  position: absolute;
  top: -28px;
  right: 6px;
  border-bottom: 20px solid #ffffff;
  border-top: 20px solid transparent;
  border-right: 20px solid transparent;
  border-left: 20px solid transparent;
}
.floating-menu .close {
  position: absolute;
  right: 4px;
  top: 7px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  line-height: 1;
  color: #b6bfc8;
  cursor: pointer;
  transition: 0.3s;
}
.floating-menu .close:hover {
  color: black;
}
.floating-menu ul li {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 15px;
  transition: 0.3s;
  padding: 5px 10px;
  border-radius: 12px;
  cursor: pointer;
}
.floating-menu ul li:hover {
  background: #f3f3f3;
}
.floating-menu ul li:first-child {
  margin-top: 0;
  border-bottom: 1px solid var(--sebrae-light-gray-2);
  padding-bottom: 15px;
  border-radius: 0;
}
.floating-menu ul li:first-child:hover {
  background-color: transparent;
  cursor: default;
}
.floating-menu ul li .title h4 {
  color: #394d60;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 8px;
}
.floating-menu ul li .title p {
  color: #8b99a7;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (min-width: 560px) {
  .floating-menu {
    right: auto;
    left: -400px;
    top: 0;
  }
}

.floating .floating-menu {
  right: 10px;
  top: 65px;
}
.floating .btn-circle {
  z-index: 2;
  position: relative;
}
@media (min-width: 560px) {
  .floating .floating-menu {
    right: auto;
    left: 58px;
    top: 0;
  }
  .floating .floating-menu:before {
    top: 0;
    left: -32px;
    right: auto;
    border-bottom: 20px solid transparent;
    border-top: 20px solid transparent;
    border-right: 20px solid #ffffff;
    border-left: 20px solid transparent;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/floating-menu/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EACA,mCAAA;AACJ;AAEE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAKI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAHN;AAKM;EACE,mBAAA;AAHR;AAMM;EACE,aAAA;EACA,mDAAA;EACA,oBAAA;EACA,gBAAA;AAJR;AAMQ;EACE,6BAAA;EACA,eAAA;AAJV;AASQ;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAPV;AAUQ;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AARV;AAcE;EA3FF;IA4FI,WAAA;IACA,YAAA;IACA,MAAA;EAXF;AACF;;AAeE;EACE,WAAA;EACA,SAAA;AAZJ;AAeE;EACE,UAAA;EACA,kBAAA;AAbJ;AAgBE;EACE;IACE,WAAA;IACA,UAAA;IACA,MAAA;EAdJ;EAgBI;IACE,MAAA;IACA,WAAA;IACA,WAAA;IACA,qCAAA;IACA,kCAAA;IACA,gCAAA;IACA,mCAAA;EAdN;AACF","sourcesContent":[".floating-menu {\n  position: absolute;\n  width: 300px;\n  right: -100%;\n  top: 65px;\n  background-color: white;\n  border-radius: 4px;\n  box-shadow: 0 2px 28px 0 rgba(20, 46, 82, 0.2);\n  padding: 15px;\n  transition: 0.3s;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: -28px;\n    right: 6px;\n    border-bottom: 20px solid #ffffff;\n    border-top: 20px solid transparent;\n    border-right: 20px solid transparent;\n    border-left: 20px solid transparent;\n  }\n\n  .close {\n    position: absolute;\n    right: 4px;\n    top: 7px;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    line-height: 1;\n    color: #b6bfc8;\n    cursor: pointer;\n    transition: 0.3s;\n\n    &:hover {\n      color: black;\n    }\n  }\n\n  ul {\n    li {\n      display: flex;\n      gap: 8px;\n      align-items: center;\n      margin-top: 15px;\n      transition: 0.3s;\n      padding: 5px 10px;\n      border-radius: 12px;\n      cursor: pointer;\n\n      &:hover {\n        background: #f3f3f3;\n      }\n\n      &:first-child {\n        margin-top: 0;\n        border-bottom: 1px solid var(--sebrae-light-gray-2);\n        padding-bottom: 15px;\n        border-radius: 0;\n\n        &:hover {\n          background-color: transparent;\n          cursor: default;\n        }\n      }\n\n      .title {\n        h4 {\n          color: #394d60;\n          font-size: 13px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: normal;\n          padding-bottom: 8px;\n        }\n\n        p {\n          color: #8b99a7;\n          font-size: 11px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: normal;\n        }\n      }\n    }\n  }\n\n  @media (min-width: 560px) {\n    right: auto;\n    left: -400px;\n    top: 0;\n  }\n}\n\n.floating {\n  .floating-menu {\n    right: 10px;\n    top: 65px;\n  }\n\n  .btn-circle {\n    z-index: 2;\n    position: relative;\n  }\n\n  @media (min-width: 560px) {\n    .floating-menu {\n      right: auto;\n      left: 58px;\n      top: 0;\n\n      &:before {\n        top: 0;\n        left: -32px;\n        right: auto;\n        border-bottom: 20px solid transparent;\n        border-top: 20px solid transparent;\n        border-right: 20px solid #ffffff;\n        border-left: 20px solid transparent;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
